import { rem } from 'polished';
import styled from '@emotion/styled';
import { Box, Text } from 'roo-ui/components';
import HorizontalRule from 'components/Layout/HorizontalRule';
import { H2 as DefaultH2 } from '../primitives';

export const PrintViewHorizontalRule = styled(HorizontalRule)`
  border: none;
  border-bottom: 1px solid #dadada;
  box-sizing: content-box;
  height: 0;
  margin: 16px 0;
  overflow: visible;
`;

export const TextContainer = ({ children, ...styleProps }) => (
  <Box my={1} {...styleProps}>
    <Text fontSize={rem(14)}>{children}</Text>
  </Box>
);

export const H2Title = styled(DefaultH2)`
  font-size: 19px;
  line-height: 32px;
  margin: 0;
`;

export const H2 = styled(DefaultH2)`
  font-size: 19px;
  line-height: 28px;
  margin: 4px 0;
`;

export const ColumnItem = ({ children }) => (
  <Box as="dl" my={1}>
    {children}
  </Box>
);

export const ItemLabel = ({ children }) => (
  <Text as="dt" fontSize="xs" color="#666" lineHeight="20px" m={0}>
    {children}
  </Text>
);

export const ItemContent = ({ children, ...style }) => (
  <Text as="dd" fontSize={rem(14)} lineHeight="20px" m={0} {...style}>
    {children}
  </Text>
);
